// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"393":"987cea51","496":"4dc82b60"}[chunkId] + ".chunk.js";
};